import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class HospitalService  {
   apiUrl = environment.apiUrl
  hospitalData:any = JSON.parse(localStorage.getItem('logindata'))
  headers:HttpHeaders
  doctorUpdateKeys=['email','regImage','countryCode','profilePicture','name','phoneNo','alternateNumber','lat','lng','address','images','registrationNo','about','discount','email','awards','membership','regImage','city','education','experience','awards','consultantFees','speciality','languages','gender','services']
  doctorAddKeys=['doctorId','timing','name','phoneNo','alternateNumber','timing','registrationNo','education']
  ambulanceAddKeys=['_id','ambulanceId','profilePicture','fullName','drivingLicence','phoneNo','registrationNo','association','vehicleNo','password','type']
  constructor(private http:HttpClient) {
    
    let accesstoken = this.hospitalData!=null ?  this.hospitalData['accessToken'] : ''
    this.headers = new HttpHeaders({    
       'content-Type': 'application/json',
       'authorization': 'Bearer '+ accesstoken ,
       'accept': 'application/json',
   
     });
   }
   updateBookingStatus(status:string,bookingID:string){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
  
    });
  
    return this.http.put(`${this.apiUrl}/Hospital/bookingStatusUpdate`,{_id:bookingID,status:status},{headers:headers1})
  }
  getUserDetail(userId){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
  
    });
    console.log(headers1)
    let params= {}
  params['userId'] = userId
  
  
  const httpOptions = {
     
    params: params
  };
  
  return this.http.get(`${this.apiUrl}/Hospital/listUsersDetails?userId=${userId}`,{headers:headers1})
  
  }
  addPrescription(bookingID,prescriptionText,description){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    });
    
    return this.http.post(`${this.apiUrl}/Hospital/addPrescription`,{bookingId:bookingID,prescription:prescriptionText,description:description},{headers:headers1})
   }
   listTreatment(hospitalData){
    
    
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    });    
     
      return this.http.get(`${this.apiUrl}/Hospital/listTreatments`,{headers:headers1})
  
}
deleteTreatment(treatmentId){
  let accesstoken = localStorage.getItem('token')
  let headers1 = new HttpHeaders({    
    'content-Type': 'application/json',
    'authorization': 'Bearer '+ accesstoken ,
    'accept': 'application/json',
  
  }); 
  return this.http.put(`${this.apiUrl}/Hospital/deleteTreatments`,{_id:treatmentId,isDeleted:true},{headers:headers1})
}
   addAmbulance(ambulanceData,isFound,ambulanceId){
     if(isFound)
        ambulanceData['ambulanceId'] = ambulanceData['_id']
   
        let ambulanceAddKeys = this.ambulanceAddKeys
        Object.keys(ambulanceData).forEach(function(key) {
  
          let exist = ambulanceAddKeys.find(ob => ob==key);
          if(exist==null)
            delete ambulanceData[key]
        
        });
        let obj={}
      if(ambulanceId){
        obj = ambulanceData
        obj['ambulanceId'] = obj['_id']
        delete obj['_id']
      }
      else{
        obj= ambulanceData
        delete obj['_id']
      }
        console.log(ambulanceData)
    
    return this.http.post(`${this.apiUrl}/Hospital/addAmbulance`,ambulanceData,{headers:this.headers})
   }
   listBookings(date=null,phoneNo=''){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    });    

   
    if (date && phoneNo) 
      return this.http.get(`${this.apiUrl}/Hospital/listBookings?date=${date}&phoneNo=${phoneNo}`,{headers:headers1})
      
    else if (phoneNo) 
      return this.http.get(`${this.apiUrl}/Hospital/listBookings?phoneNo=${phoneNo}`,{headers:headers1})
    else if(date)
      return this.http.get(`${this.apiUrl}/Hospital/listBookings?date=${date}`,{headers:headers1})
    else
    return this.http.get(`${this.apiUrl}/Hospital/listBookings`,{headers:headers1})
    
   }
  
   addDoctor123(doctorData,timingDoctor,isFound){
    if(isFound)
      doctorData['doctorId'] = doctorData['_id']
    doctorData["timing"]  = timingDoctor

      let doctorAddKeys = this.doctorAddKeys
      Object.keys(doctorData).forEach(function(key) {

        let exist = doctorAddKeys.find(ob => ob==key);
        if(exist==null)
          delete doctorData[key]
      
      });
    
    console.log(doctorData)
   

    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    });    
   
    return this.http.post(decodeURI(`${this.apiUrl}/Hospital/addHospitalDoctor`),doctorData,{headers:headers1})
  }
  
  // searchDoctor(phoneNo:number){
  //   let accesstoken = localStorage.getItem('token')
  //   let headers1 = new HttpHeaders({    
  //     'content-Type': 'application/json',
  //     'authorization': 'Bearer '+ accesstoken ,
  //     'accept': 'application/json',
    
  //   });    
  //   return this.http.post(`${this.apiUrl}/Hospital/serachDoctor`,{phoneNo : phoneNo},{headers:headers1})
  // }
  searchDoctor(phoneNo:number,countryCode='+91'){
       let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    });   
    return this.http.post(`${this.apiUrl}/Hospital/serachDoctor`,{phoneNo : phoneNo,countryCode:countryCode},{headers:headers1})
     
  
  
    
  }
  doctorCheckOtp(phoneNo,otp,countryCode='91'){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    }); 
    return this.http.post(`${this.apiUrl}/Hospital/doctorOtpVerify`,{phoneNo:phoneNo,otp:otp,countryCode:countryCode},{headers:headers1})
    
      
  
    }
  
  searchAmbulance(phoneNo:number,countryCode='91'){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    });  
    return this.http.post(`${this.apiUrl}/Hospital/serachAmbulance`,{phoneNo : phoneNo,countryCode:countryCode},{headers:headers1})
  }
  getambulanceDoctor(){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    });  
    return this.http.post(`${this.apiUrl}/Hospital/listDoctorAmbulance`,{},{headers:headers1})
  }
  addTreatment(hospitalTreatmentData,hospitalData){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    });  
    delete hospitalTreatmentData['hospitalId']
   
    return this.http.post(`${this.apiUrl}/Hospital/addEditTreatments`,hospitalTreatmentData,{headers:headers1})
  }
  updateHospitalTreatment(testObj,hospitalData){
  
      //console.log(testObj)
      
     // delete testObj['_id']
      delete testObj['createdAt']
      delete testObj['doctorId']
      delete testObj['hospitalId']
      delete testObj['discount']
      delete testObj['__v']
      delete testObj['isDeleted']
     // testObj['_id'] = hospitalData['_id']
    console.log(testObj)

    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    });  
    return this.http.post(`${this.apiUrl}/Hospital/addEditTreatments`,testObj,{headers:headers1})
  }
  getBlog(id){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    });  
    return this.http.get(`${this.apiUrl}/Hospital/listBlog?_id=${id}`,{headers:headers1})
  }
  getBlogs(hospitalData){ 
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    }); 
   
    return this.http.get(`${this.apiUrl}/Hospital/listBlog`,{headers:headers1})
  }
  addEditBlog(blog,id){
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({    
      'content-Type': 'application/json',
      'authorization': 'Bearer '+ accesstoken ,
      'accept': 'application/json',
    
    }); 
  
    delete blog["hospitalId"]
    if(id)
      blog['_id'] = blog._id
      delete blog['doctorId']
      delete blog['createdAt']
      delete blog['__v']
      delete blog['adminVerified']
      delete blog['isDeleted']
      delete blog['uniquekey']
      //blog['doctorId'] = this.doctorData['_id']
    console.log(blog)  
    return this.http.post(`${this.apiUrl}/Hospital/addEditBlog`,blog,{headers:headers1})
  
  }


  // USer Side////

  getHospitalList(object={value:{name:'',city:'',treatment:''}}){
    let lat = localStorage.getItem('lat') 
    let lng = localStorage.getItem('lng') 
    let params= {}
    if(lat=='undefined'){}
    else{ 
      params["lat"] = lat
    }
    if (lng=='undefined') {}
    else{
      params["lng"] = lng 
    }

    if(object.value.name)
      params["name"] = object.value.name
    if(object.value.treatment)
      params["treatment"] = object.value.treatment
    if(object.value.city)
      params["city"] = object.value.city.toLowerCase()

    
    const httpOptions = {
     
      params: params
  };
  
    return this.http.get(`${this.apiUrl}/User/listHospital`,httpOptions)
  }
  getHospitalDetail(hospitalId:string){
    let params= {}
    params['_id'] = hospitalId
    const httpOptions = {
       
      params: params
    };
    return this.http.get(`${this.apiUrl}/User/listHospitalDetailData`,httpOptions)
    }
    setPasword(password){
      let accesstoken = localStorage.getItem('token')
      let headers1 = new HttpHeaders({    
        'content-Type': 'application/json',
        'authorization': 'Bearer '+ accesstoken ,
        'accept': 'application/json',
      
      });
      
      return this.http.put(`${this.apiUrl}/Hospital/setPassword`,{ password : password},{headers:headers1})
    }
    deleteBlog(blogId){
      let accesstoken = localStorage.getItem('token')
      let headers1 = new HttpHeaders({    
        'content-Type': 'application/json',
        'authorization': 'Bearer '+ accesstoken ,
        'accept': 'application/json',
    
      });
      return this.http.put(`${this.apiUrl}/Hospital/deleteBlog`,{blogId:blogId,isDeleted:true},{headers:headers1})
    }
    getReviews(){
      let accesstoken = localStorage.getItem('token')
      let headers1 = new HttpHeaders({    
        'content-Type': 'application/json',
        'authorization': 'Bearer '+ accesstoken ,
        'accept': 'application/json',
    
      });
    
    
      return this.http.get(`${this.apiUrl}/Hospital/listReview`,{headers:headers1})
    

}
getDoctorDetail(doctorId,hospitalId){
  return this.http.get(`${this.apiUrl}/User/listDoctorDetailData?_id=${doctorId}&hospitalId=${hospitalId}`)
}
getDoctorDetailHospitalSide(doctorId,hospitalId){
  return this.http.get(`${this.apiUrl}/Hospital/listDoctorDetailData?_id=${doctorId}&hospitalId=${hospitalId}`)
}
getDoctorDetailWithDate(doctorId,hospitalId,date){
  let params= {}
params['_id'] = doctorId
params['bookingDate'] = date
params['hospitalId'] = hospitalId

const httpOptions = {
   
  params: params
};
  return this.http.get(`${this.apiUrl}/User/listDoctorDetailData`,httpOptions)
}
doctorResendOtp(phoneNo:any,countryCode='91'){
  //localStorage.setItem('phoneNo',phoneNo)
 
  let token =  localStorage.getItem('token')
  let headers =new HttpHeaders({   
    'content-Type': 'application/json',
    'authorization': 'Bearer '+ token,
    'accept': 'application/json',

  });  
 
    return this.http.post(`${this.apiUrl}/Hospital/doctorOtpResend`,{phoneNo:phoneNo,countryCode:countryCode},{headers:headers})

  
}
profileAddTiming(timing,doctorId){
  let token =  localStorage.getItem('token')
  let headers =new HttpHeaders({   
    'content-Type': 'application/json',
    'authorization': 'Bearer '+ token,
    'accept': 'application/json',

  }); 

  return  this.http.put(`${this.apiUrl}/Hospital/addDoctorTiming`,{timing:timing,doctorId:doctorId},{headers:headers})
}
profileAddDoctor(data:any,doctorId){
  let token =  localStorage.getItem('token')
  let headers =new HttpHeaders({   
    'content-Type': 'application/json',
    'authorization': 'Bearer '+ token,
    'accept': 'application/json',

  });  
 console.log(data)
    // For doctor
  
    let doctorUpdateKeys = this.doctorUpdateKeys
    Object.keys(data).forEach(function(key) {

      let exist = doctorUpdateKeys.find(ob => ob==key);
      if(exist==null)
        delete data[key]
    
    });

    if(!data['discount'])
      data['discount']=0
    if(!data['alternateNumber'])
      delete data['alternateNumber']
    if(!data['email'])
      delete data['email']
    if(!data['consultantFees'])
      delete data['consultantFees']


if(doctorId!='')
  data["doctorId"] = doctorId

  console.log(data)

  return  this.http.post(`${this.apiUrl}/Hospital/addHospitalDoctor`,data,{headers:headers})
  
}
getPatientGraphData(){
  let accesstoken = localStorage.getItem('token')
  let headers1 = new HttpHeaders({    
    'content-Type': 'application/json',
    'authorization': 'Bearer '+ accesstoken ,
    'accept': 'application/json',

  });


  return this.http.get(`${this.apiUrl}/Hospital/patientGraph`,{headers:headers1})
}
getRevenueGraphData(){
  let accesstoken = localStorage.getItem('token')
  let headers1 = new HttpHeaders({    
    'content-Type': 'application/json',
    'authorization': 'Bearer '+ accesstoken ,
    'accept': 'application/json',

  });


  return this.http.get(`${this.apiUrl}/Hospital/revenueGraph`,{headers:headers1})
}
doctorBooking(doctorBookingData,hospitalId){
  let accesstoken = localStorage.getItem('token')
  let headers1 = new HttpHeaders({    
    'content-Type': 'application/json',
    'authorization': 'Bearer '+ accesstoken ,
    'accept': 'application/json',
  
  });
 doctorBookingData['hospitalId'] = hospitalId
 console.log(doctorBookingData)
  
  return this.http.post(`${this.apiUrl}/User/hospitalDoctorbooking`,doctorBookingData,{headers:headers1})
}
bookHospital(hospitalBookingData,hospitalId){
  let accesstoken = localStorage.getItem('token')
  let headers1 = new HttpHeaders({    
    'content-Type': 'application/json',
    'authorization': 'Bearer '+ accesstoken ,
    'accept': 'application/json',
  
  });
  hospitalBookingData['hospitalId'] = hospitalId
 console.log(hospitalBookingData)
  
  return this.http.post(`${this.apiUrl}/User/hospitalBooking`,hospitalBookingData,{headers:headers1})
}
bookHospitalByHospital(hospitalBookingData){
  let accesstoken = localStorage.getItem('token')
  let headers1 = new HttpHeaders({    
    'content-Type': 'application/json',
    'authorization': 'Bearer '+ accesstoken ,
    'accept': 'application/json',
  
  });
  
 console.log(hospitalBookingData)
  
  return this.http.post(`${this.apiUrl}/Hospital/createOrder`,hospitalBookingData,{headers:headers1})
}

}
